import styled from 'styled-components';

const mapTransformX = (props) => {
  const { position } = props;
  const right = position.includes("right");
  const center = position.includes("center");
  const left = position.includes("left");
  if (right)
    return "translateX(calc(100% + 10px))";
  if (left)
    return "translateX(calc(-100% - 10px))";
  if (center)
    return "translateX(-50%)";
  return "translateX(0)";
};
const mapLeft = (props) => {
  const { position } = props;
  const center = position.includes("center");
  const left = position.includes("left");
  if (left)
    return "0";
  if (center)
    return "50%";
  return "initial";
};
const ShareProductButtonStyled = styled.div`
  cursor: pointer;
  position: relative;
  display: inline-flex;

  .ShareButton {
    &__tooltip {
      background: #000000;
      color: #ffffff;
      padding: 4px 8px;
      border-radius: 4px;
      position: absolute;
      white-space: nowrap;
      font-size: 12px;
      top: ${(props) => props.position.includes("top") ? "calc(-100% - 10px)" : "initial"};
      right: ${(props) => props.position.includes("right") ? "0" : "initial"};
      bottom: ${(props) => props.position.includes("bottom") ? "calc(-100% - 10px)" : "initial"};
      left: ${mapLeft};
      transform: ${mapTransformX};
      z-index: 2;
    }
  }

  .Icon {
    svg {
      width: 100%;
    }
  }
`;

export { ShareProductButtonStyled as default };
//# sourceMappingURL=bundle.esm2.js.map
